module.exports = __webpack_public_path__ + "media/images/close-big-800497450767957bf6155a16545e135c.svg";